import PropTypes from "prop-types";
import React from "react";

/**
 * Clickable logo in the header that goes back to the company page.
 * Using a SVG instead of a png due to issues with the Parcel URL reference
 * leading to a `Cannot use 'import.meta' outside a module` error
 *
 * @returns {React.Element}
 */
const SiteLogo = ({ size }) => (
  <svg
    height={size}
    viewBox="0 0 219 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M67.5407 30.8399H84.6707V36.5999H60.0007V30.8399L76.6107 8.75988H61.3907V2.99988H84.1007V8.75988L67.5407 30.8399Z"
      fill="white"
    />
    <path
      d="M101.251 25.4797L108.751 36.5997H116.411L105.071 19.7997L101.251 25.4797Z"
      fill="white"
    />
    <path
      d="M98.8306 10.5498L93.7406 2.99976H86.0806L95.0006 16.2198L98.8306 10.5498Z"
      fill="white"
    />
    <path
      d="M93.7406 36.5998H86.0806L108.751 2.99976H116.411L93.7406 36.5998Z"
      fill="white"
    />
    <path
      d="M118.411 36.5998L124.931 2.99976H134.911C139.271 2.99976 142.751 4.26976 145.361 6.81976C147.971 9.35976 149.271 12.8798 149.271 17.3598C149.271 23.1798 147.331 27.8498 143.441 31.3498C139.551 34.8498 134.651 36.6098 128.731 36.6098H118.411V36.5998ZM121.581 34.0998H128.971C133.871 34.0998 138.001 32.5998 141.381 29.5898C144.761 26.5798 146.441 22.5498 146.441 17.4898C146.441 13.6798 145.361 10.7298 143.201 8.62976C141.041 6.52976 138.151 5.48976 134.541 5.48976H127.201L121.581 34.0998Z"
      fill="white"
    />
    <path
      d="M161.361 37.3197C158.351 37.3197 155.941 36.3597 154.111 34.4397C152.291 32.5197 151.371 29.9797 151.371 26.8097C151.371 23.0997 152.561 19.9897 154.951 17.4697C157.331 14.9597 160.301 13.6997 163.851 13.6997C166.121 13.6997 168.081 14.2297 169.731 15.2797C171.381 16.3297 172.521 17.8097 173.161 19.6997H173.261L174.271 14.4197H176.771L172.451 36.5997H169.951L170.771 32.5697H170.671C168.301 35.7397 165.201 37.3197 161.361 37.3197ZM162.181 34.9197C165.121 34.9197 167.581 33.8997 169.551 31.8497C171.521 29.7997 172.501 27.2597 172.501 24.2197C172.501 21.7597 171.741 19.7897 170.221 18.3197C168.701 16.8497 166.641 16.1097 164.051 16.1097C161.231 16.1097 158.861 17.1397 156.921 19.2097C154.981 21.2697 154.021 23.8297 154.021 26.8697C154.021 29.3297 154.761 31.2897 156.231 32.7497C157.701 34.2097 159.691 34.9297 162.181 34.9297V34.9197Z"
      fill="white"
    />
    <path
      d="M187.481 16.5398L184.741 30.5598C184.641 31.0998 184.601 31.5998 184.601 32.0498C184.601 32.7198 184.821 33.2698 185.251 33.6798C185.681 34.0998 186.301 34.2998 187.101 34.2998H188.491L188.061 36.6998H186.521C185.141 36.6998 184.061 36.3198 183.261 35.5498C182.461 34.7798 182.061 33.7398 182.061 32.4298C182.061 31.9198 182.121 31.3098 182.251 30.6098L184.991 16.5498H180.331L180.761 14.4398H185.371L187.101 5.55975H189.601L187.871 14.4398H193.151L192.721 16.5498H187.491L187.481 16.5398Z"
      fill="white"
    />
    <path
      d="M202.65 37.3197C199.64 37.3197 197.23 36.3597 195.4 34.4397C193.58 32.5197 192.66 29.9797 192.66 26.8097C192.66 23.0997 193.85 19.9897 196.24 17.4697C198.62 14.9597 201.59 13.6997 205.14 13.6997C207.41 13.6997 209.37 14.2297 211.02 15.2797C212.67 16.3297 213.81 17.8097 214.45 19.6997H214.55L215.56 14.4197H218.06L213.74 36.5997H211.24L212.06 32.5697H211.96C209.59 35.7397 206.49 37.3197 202.65 37.3197ZM203.47 34.9197C206.41 34.9197 208.87 33.8997 210.84 31.8497C212.81 29.7997 213.79 27.2597 213.79 24.2197C213.79 21.7597 213.03 19.7897 211.51 18.3197C209.99 16.8497 207.93 16.1097 205.34 16.1097C202.52 16.1097 200.15 17.1397 198.21 19.2097C196.27 21.2697 195.31 23.8297 195.31 26.8697C195.31 29.3297 196.05 31.2897 197.52 32.7497C198.99 34.2097 200.98 34.9297 203.47 34.9297V34.9197Z"
      fill="white"
    />
    <circle cx="6.66715" cy="6.66715" r="6.66667" fill="white" />
    <circle cx="33.3341" cy="33.3332" r="6.66667" fill="white" />
    <rect
      x="28.4858"
      y="2.08649"
      width="13.3333"
      height="38.6667"
      transform="rotate(45 28.4858 2.08649)"
      fill="#00E6F6"
    />
    <circle cx="6.66667" cy="33.3332" r="6.66667" fill="white" />
    <circle cx="33.3337" cy="6.66667" r="6.66667" fill="white" />
  </svg>
);

SiteLogo.propTypes = {
  size: PropTypes.number,
};

SiteLogo.defaultProps = {
  size: 20,
};

export default SiteLogo;
